<script setup>
import 'viewerjs/dist/viewer.css'
import { api as viewerApi } from "v-viewer"

const props = defineProps({
    medias: Array,
})

const getThumbnailUrl = (url) => {
    return `/format-image/${url}?w=400&h=200&fit=crop&format=webp`;
};

const previewImage = (clickedImageUrl, event) => {
    event.preventDefault()

    const initialViewIndex = props.medias.findIndex(url => url === clickedImageUrl);

    viewerApi({
        images: props.medias,
        options: {
            toolbar: false,
            transition: true,
            loading: true,
            initialViewIndex: initialViewIndex,
            keyboard: true,
        }
    })
}
</script>

<template>
    <div>
        <div class="row g-3">
            <div
                v-for="(url, index) in props.medias"
                :key="index"
                class="col-xl-3 col-lg-4 col-md-6 col-sm-6"
            >
                <div class="card border">
                    <div class="position-relative">
                        <img
                            :src="getThumbnailUrl(url)"
                            :alt="`Photo ${index + 1}`"
                            class="card-img-top shadow-sm"
                            style="height: 200px; object-fit: cover; cursor: pointer;"
                            @click="previewImage(url, $event)"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
